<template>
    <div :key="'labTest' + labTest.id" class="mt-2 hover-cell" @click="$emit('edit', labTest)">
        <v-card>
            <v-card-text class="pa-2">
                {{ labTest.name }}
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    export default {
        props: {
            labTest: {
                type: Object,
                default: null,
            },
        },
    };
</script>
<style scoped>
    .hover-cell {
        cursor: pointer;
    }
</style>
